import { RealmResponseDto } from '../dto/auth/realm-response-dto';
import { RealmModel } from '../interface/auth/realm-model';

export class RealmMapper {
    public mapModelToDto(realm: RealmModel): RealmResponseDto {
        return {
            id: realm.id,
            name: realm.name,
            defaultAccessTokenLifespan: realm.defaultAccessTokenLifespan,
            defaultAuthenticationFlow: realm.defaultAuthenticationFlow,
            enabled: realm.enabled,
            description: realm.description,
            usernameField: realm.usernameField,
            createdAt: realm.createdAt,
            updatedAt: realm.updatedAt,
        };
    }

    public mapDtoToModel(dto: RealmResponseDto): RealmModel {
        return {
            id: dto.id,
            name: dto.name,
            defaultAccessTokenLifespan: dto.defaultAccessTokenLifespan,
            defaultAuthenticationFlow: dto.defaultAuthenticationFlow,
            enabled: dto.enabled,
            description: dto.description,
            usernameField: dto.usernameField,
            createdAt: dto.createdAt,
            updatedAt: dto.updatedAt,
        };
    }
}
